import * as angular from 'angular';

import { Log, ComponentDefinition, } from '../../../models';
import { WidgetBase, IWidgetConfiguration } from '../../../widgets';
import { Helper } from '../../../common/helpers';

class LogStackTraceController implements angular.IComponentController {
    isLoading: boolean;
    loadingMessage: string;

    readonly selectedLog: Log;

    static $inject = ['$translate'];

    constructor(private _$translate: angular.translate.ITranslateService) {
    }

    stacktrace(log: Log): string {
        this.isLoading = true;
        let stacktrace: string = this._$translate.instant('No stacktrace');
        if (log && log.stacktrace && log.stacktrace.length > 0) {
            const join: string = log.stacktrace.join('\n');
            if (join.length > 0) {
                stacktrace = join;
            }
        }

        this.isLoading = false;
        return stacktrace;
    }
}

export const wtLogStackTrace: ComponentDefinition = {
    componentId: 'wtLogStackTrace',
    controller: LogStackTraceController,
    template: require('./logStackTrace.component.html'),
    controllerAs: 'vm',
    bindings: {
        selectedLog: '<'
    }
};

export class LogStacktraceWidget extends WidgetBase {
    baseType = 'logStacktrace';
    col = 0;
    guid: string;
    highlights = ['A component showing the stacktrace of a log'];
    icon = 'fa-table';
    name = 'LogStacktrace';
    row = 0;
    sizeX = 6;
    sizeY = 6;
    type = 'logStacktrace';

    constructor(config?: IWidgetConfiguration) {
        super();
        this.setConfiguration(config);

        this.guid = Helper.getGuid();
    }
}
